import { $ } from '@/Engine/state';
import { Color } from 'three';

export function getScreenShot() {
    const { renderer, scene, camera } = $.app;
    const canvas = document.getElementsByClassName('v3d-canvas')[0] as HTMLCanvasElement;

    const oldColor  = renderer.getClearColor(new Color()).clone();
    const oldAlpha  = renderer.getClearAlpha();
    const oldBg     = scene.background;
    // renderer.setClearColor('#ffffff', 1);
    renderer.setClearColor(0x000000, 0);
    scene.background = null;
    renderer.setClearAlpha(0);

    $.toolChest?.visibleWf(false);
    renderer.render(scene, camera);

    const dataURL = canvas.toDataURL('image/png');

    //возвращ исходные настройки сцены
    $.toolChest?.visibleWf(true);
    scene.background = oldBg;
    renderer.setClearColor(oldColor, oldAlpha);

    $.render();
    return dataURL;
}

export function getScreenshotWithPosition(targetWidth = 600, targetHeight = 600) {
    const { renderer, scene, camera } = $.app;

    const oldCameraPosition = camera.position.clone();
    const oldCameraRotation = camera.rotation.clone();
    const oldRendererSize = {
        width: renderer.domElement.width,
        height: renderer.domElement.height,
    };
    const oldPixelRatio = renderer.getPixelRatio();
    const oldAspect = camera.aspect;

    let screenshot;
    let error;

    try {
        camera.position.set(-2.4, 1, 5.63);
        camera.rotation.set(-0.01, -0.43, -0.01);

        renderer.setSize(targetWidth, targetHeight, false);
        renderer.setPixelRatio(1);

        camera.aspect = targetWidth / targetHeight;
        camera.updateProjectionMatrix();

        screenshot = getScreenShot();

    } catch (e) {
        error = e;
    }

    renderer.setSize(oldRendererSize.width, oldRendererSize.height, false);
    renderer.setPixelRatio(oldPixelRatio);
    camera.aspect = oldAspect;
    camera.updateProjectionMatrix();
    camera.position.copy(oldCameraPosition);
    camera.rotation.copy(oldCameraRotation);
    $.render();

    if (error) throw error;
    return screenshot;
}
